module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "close icon-cross-circle",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), (!_vm.showResponse) ? _c('form', {
    staticClass: "contact-form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.send($event)
      }
    }
  }, [_c('label', {
    staticClass: "small",
    attrs: {
      "for": "contact-subject-field"
    }
  }, [_vm._v("Subject")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject),
      expression: "subject"
    }],
    attrs: {
      "name": "subject",
      "id": "contact-subject-field"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.subject = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.subjects), function(subOpt, si) {
    return _c('option', {
      key: [subOpt.key, si].join('_'),
      domProps: {
        "value": subOpt.key
      }
    }, [_vm._v(_vm._s(subOpt.value))])
  })), _vm._v(" "), _c('label', {
    staticClass: "small",
    attrs: {
      "for": "contact-name-field"
    }
  }, [_vm._v("Contact name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactName),
      expression: "contactName"
    }],
    staticClass: "textfield plain-text",
    attrs: {
      "type": "text",
      "maxlength": "255",
      "size": "64",
      "required": "true",
      "placeholder": "Your name / organisation",
      "id": "contact-name-field"
    },
    domProps: {
      "value": (_vm.contactName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "small",
    attrs: {
      "for": "contact-email-field"
    }
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "textfield mail",
    attrs: {
      "type": "email",
      "maxlength": "255",
      "size": "64",
      "placeholder": "Contact email address",
      "id": "contact-email-field"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "small",
    attrs: {
      "for": "contact-body-field"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body),
      expression: "body"
    }],
    staticClass: "textfield multi-line",
    attrs: {
      "rows": "6",
      "cols": "64",
      "placeholder": "Write a message...",
      "id": "contact-body-field"
    },
    domProps: {
      "value": (_vm.body)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.body = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.error) ? _c('ul', {
    staticClass: "error messages"
  }, _vm._l((_vm.errorMsgs), function(msg, eri) {
    return _c('li', {
      key: ['error-msg', eri].join('_')
    }, [_vm._v(_vm._s(msg))])
  })) : _vm._e(), _vm._v(" "), (_vm.maySubmit) ? _c('button', {
    staticClass: "button submit",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "icon-send"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Send")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showResponse) ? _c('div', {
    staticClass: "response",
    domProps: {
      "innerHTML": _vm._s(_vm.responseText)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b598252"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 93
// module chunks = 1